export const instruments = {
    instrument1: {
        solventMapping: {
            CDCl3: 'CDCl3',
            'DMSO-d6': 'DMSO-d6',
        },
        defaultExperiments: {
            '1h': 'N proton',
            '13c': 'N carbon',
            cosy: 'N COSY',
        },
        experiments: [
            {
                experiment: 'N proton',
                enabled: true,
                parameters: [
                    { label: 'd1', value: '' },
                    { label: 'd9', value: '' },
                ],
            },
            {
                experiment: 'N carbon',
                parameters: [
                    { label: 'ds', value: '' },
                    { label: 'ns', value: '' },
                    { label: 'd1', value: '' },
                ],
            },
            {
                experiment: 'N COSY',
                parameters: [],
            },
        ],
    },
    instrument2: {
        solventMapping: {
            CDCl3: 'Chloroform-d',
            'DMSO-d6': 'Dimethyl sulfoxide-d6',
        },
        defaultExperiments: {
            '1h': 'H1 NMR',
            '13c': 'C13 NMR',
            hsqc: 'HSQC',
        },
        experiments: [
            {
                experiment: 'H1 NMR',
                parameters: [
                    { label: 'd1', value: '' },
                    { label: 'number of scans', value: '' },
                ],
            },
            {
                experiment: 'C13 NMR',
                parameters: [
                    { label: 'ds', value: '' },
                    { label: 'ns', value: '' },
                    { label: 'd1', value: '' },
                ],
            },
            {
                experiment: 'HSQC',
                parameters: [],
            },
        ],
    },
};
//# sourceMappingURL=instruments.js.map